import { 
  faTv,
  faTrophy,
  faCalendarAlt,
  faNewspaper,
  faFutbol,
  faChartLine,
  faList
} from '@fortawesome/free-solid-svg-icons'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

export interface MenuItem {
  href: string
  icon: IconDefinition
  text: string
}

export const menuItems: MenuItem[] = [
  { href: '/', icon: faTv, text: 'XOILAC' },
  { href: '/kqbd', icon: faTrophy, text: 'KẾT QUẢ' },
  { href: '/lich-thi-dau-bong-da', icon: faCalendarAlt, text: 'LỊCH ĐẤU' },
  { href: '/bang-xep-hang-bong-da', icon: faList, text: 'XẾP HẠNG' },
  { href: '/tin-bong-da', icon: faNewspaper, text: 'TIN TỨC' },
  { href: '/nhan-dinh-bong-da', icon: faChartLine, text: 'NHẬN ĐỊNH' },
  { href: '/highlights', icon: faFutbol, text: 'HIGHLIGHT' },
] 